import { QUICK_INFO_BUTTONS } from '@aibees/elephant/components/quick-info-group/components/quick-info-button';
import {
  ProcessingItemState,
  useActionButtonContext,
} from '@aibees/elephant/context/action-button-context';
import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { PersonContactDetailsItem } from '@aibees/elephant/feature/search-table-people/types';
import { ENRICHMENT_STATE } from '@aibees/elephant/types';
import { useEffect } from 'react';

export function useCheckContactDetailsProcessing(item?: PeopleTableInfo) {
  const { removeProcessingItems, getItemState } = useActionButtonContext();

  useEffect(() => {
    const id = item?.id ?? '';
    const state = item?.revelation?.contact?.state;
    if (
      !!state &&
      (state === ENRICHMENT_STATE.SUCCESS || state === ENRICHMENT_STATE.FAILED)
    ) {
      removeProcessingItems({
        id,
        type: QUICK_INFO_BUTTONS.CONTACT_ENRICHMENT,
      });
      return;
    }

    // CONTACT_UPDATE_JOB_CHANGE on a not-yet-unlocked profile never sets
    // revelation.contact.state, so the SUCCESS/FAILED gate above never fires.
    // Backend clears data.changes.CONTACT only when the job-change update
    // completes, so use that as the completion signal for this flow.
    const processingState = getItemState({
      id,
      type: QUICK_INFO_BUTTONS.CONTACT_ENRICHMENT,
    });
    if (
      processingState === ProcessingItemState.UPDATING_JOB_CHANGE &&
      !item?.changes?.CONTACT?.includes(PersonContactDetailsItem.EXPERIENCE)
    ) {
      removeProcessingItems({
        id,
        type: QUICK_INFO_BUTTONS.CONTACT_ENRICHMENT,
      });
    }
  }, [item]);

  return null;
}
